import { create } from 'zustand'

type PropertiesStoreT = {
  deletedPropertiesIds: string[]
  addDeletedPropertiesId: (id: string) => void
}

export const usePropertiesStore = create<PropertiesStoreT>(set => ({
  deletedPropertiesIds: [],
  addDeletedPropertiesId: id => {
    set(state => {
      const updated = [...state.deletedPropertiesIds, id]
      return { deletedPropertiesIds: updated }
    })
  },
}))
